export { default } from './ArrowLongLeft'
